[
  {
    "code": "BD-1",
    "name": "Barisal bibhag"
  },
  {
    "code": "BD-2",
    "name": "Chittagong bibhag"
  },
  {
    "code": "BD-3",
    "name": "Dhaka bibhag"
  },
  {
    "code": "BD-4",
    "name": "Khulna bibhag"
  },
  {
    "code": "BD-5",
    "name": "Rajshahi bibhag"
  },
  {
    "code": "BD-6",
    "name": "Sylhet bibhag"
  }
]